/*
 *
 * SetPassword constants
 *
 */

export const VALIDATE_USER_WATCHER = "app/SetPassword/VALIDATE_USER_WATCHER"
export const VALIDATE_USER_SUCCESS = "app/SetPassword/VALIDATE_USER_SUCCESS"
export const VALIDATE_USER_FAILED = "app/SetPassword/VALIDATE_USER_FAILED"

export const SET_PASSWORD_WATCHER = "app/SetPassword/SET_PASSWORD_WATCHER"
export const SET_PASSWORD_SUCCESS = "app/SetPassword/SET_PASSWORD_SUCCESS"
export const SET_PASSWORD_FAILED = "app/SetPassword/SET_PASSWORD_FAILED"
